interface Props {
  onSelect: () => void;
}

export default function CustomScheduleCard({ onSelect }: Props) {
  return (
    <div className="flex min-h-64 w-full flex-col justify-center rounded-2xl border-2 border-taupe bg-beige-light-20 p-4 px-4 py-4">
      <div className="mb-4 flex items-center justify-between">
        <div className="flex flex-wrap items-center justify-start gap-x-2 gap-y-1">
          <span className="flex items-center justify-start gap-x-2 text-xl font-medium text-green-primary-text">
            Build your own
          </span>
        </div>

        <button
          onClick={onSelect}
          className="rounded-full border border-green-dark-2 bg-green-dark-2 px-3 py-[7px] text-xs font-bold uppercase text-neutral-offWhite"
          type="button"
        >
          Select
        </button>
      </div>
      <div className="w-full border-b border-dashed border-taupe" />
      <p className="py-4 text-base font-light text-brown">
        {
          "Don't see a pattern that fits? Draw your own rotation, one day at a time - pick how often it repeats, then tap any day to switch parents."
        }
      </p>
      <div className="w-full border-b border-dashed border-taupe" />
    </div>
  );
}
